import type { DrawGoodsVo, GoodsMissionVO } from '~/types/auto/actuator';
import type {
  ContestVO as ContestVO2,
  MyHomeDataVo,
  ProblemRecommendSectionVO,
  ProblemRecommendVO,
  NoviceTaskList
} from '~/types/auto/oj';
import type { Pagination } from '~/types/common';
import type { ContestListRequestVO, ContestVO } from '~/types/contest';
import type { CMyGroupApplylistResVO, HomeInfoVO } from '~/types/home';
import type { ProblemVO } from '~/types/problem';
import { httpService } from '../http';

export function getMyProblemRecord(query: { pass?: boolean }) {
  return httpService.get<Pagination<ProblemVO>>(
    `/api/code-community/api/my/problemRecord`,
    { query },
  );
}

export function getMyContestRecord(query?: ContestListRequestVO) {
  return httpService.get<Pagination<ContestVO>>(
    `/api/code-community/api/my/contestRecord`,
    { query },
  );
}

export function getRegisteredContestList(query?: ContestListRequestVO) {
  return httpService.get<Pagination<ContestVO>>(
    `/api/code-community/api/get-registered-contest-list`,
    { query },
  );
}

export function getNotRegisteredContestList(query?: ContestListRequestVO) {
  return httpService.get<Pagination<ContestVO>>(
    `/api/code-community/api/get-not-registered-contest-list`,
    { query },
  );
}

export function getMyHomeRecord(query?: any) {
  return httpService.get<HomeInfoVO>(`/api/code-community/api/my/homeData`, {
    query,
  });
}

export function getMyNewUserData(query?: any) {
  return httpService.get<MyHomeDataVo>(
    `/api/code-community/api/my/newUserData`,
    {
      query,
    },
  );
}

export function getApplyList(query: any) {
  return httpService.get<Pagination<CMyGroupApplylistResVO>>(
    `/api/code-community/api/group/my-apply-list`,
    {
      query,
    },
  );
}

export function getHotContests() {
  return httpService.get<Array<ContestVO2>>(
    `/api/code-community/api/home-get-hot-contests`,
  );
}
export function getRecommendSections() {
  return httpService.get<Array<ProblemRecommendSectionVO>>(
    `/api/code-community/api/home-get-recommend-sections`,
  );
}
export function getProblemRecommend(configId: number) {
  return httpService.get<ProblemRecommendVO[]>(
    `/api/code-community/api/home-get-problem-recommend`,
    { query: { configId } },
  );
}

export function getGoodsByWeek() {
  return httpService.get<GoodsMissionVO>(
    `/api/code-community-actuator/api/user/mission/goods-by-week`,
  );
}

export function drawGoods(drawCount: number, missionId: number) {
  return httpService.get<DrawGoodsVo>(
    `/api/code-community-actuator/api/user/mission/draw-goods`,
    { query: { drawCount, missionId } },
  );
}

export function decorateGoods(goodsId: number) {
  return httpService.get(
    `/api/code-community-actuator/api/user/mission/decorate-goods`,
    { query: { goodsId } },
  );
}

export function offloadGoods(goodsId: number) {
  return httpService.get(
    `/api/code-community-actuator/api/user/mission/offload-goods`,
    { query: { goodsId } },
  );
}

export function getNoviceTask() {
  return httpService.get<NoviceTaskList>(`/api/code-community/api/get-novice-task`);
}